import { render, staticRenderFns } from "./ingredients.vue?vue&type=template&id=7046dba7&scoped=true&"
import script from "./ingredients.vue?vue&type=script&lang=js&"
export * from "./ingredients.vue?vue&type=script&lang=js&"
import style0 from "./ingredients.vue?vue&type=style&index=0&id=7046dba7&prod&lang=scss&"
import style1 from "./ingredients.vue?vue&type=style&index=1&id=7046dba7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7046dba7",
  null
  
)

export default component.exports